<template>
    <article class="article-wrapper article6">
        <audio src="@/assets/audio/noise.mp3" type="audio/mpeg"
        ref="noiseMusic" loop preload></audio>
        <audio :src="data.audio_path" type="audio/mpeg"
        ref="radioMusic" preload></audio>
        <audio v-if="targetIdx===0" src="@/assets/audio/section6_h.mp3" type="audio/mpeg"
        ref="hoverMusic" preload></audio>
        <audio v-if="targetIdx===2" src="@/assets/audio/section6_h_v3.mp3" type="audio/mpeg"
        ref="hoverMusic" preload></audio>
        <div id="article6Photo" class="photo-wrapper" v-if="!$store.state.isDivinationOpen">
            <div class="fade16" :class="{'active': $parent.isfadeInActive && $parent.isfadeInA6}"
            @click="playTV();gaEvent('play_btn', 'tv_play');"
            v-if="targetIdx===1">
                <img src="@/assets/images/article6/img_article6_tv.png"
                class="photo"/>
                <video ref="tvVideo" width="100%" height="100%" preload playsinline
                class="tv-video">
                    <source src="@/assets/video/img_article6_tv_video.mp4" type="video/mp4">
                </video>
                <img src="@/assets/images/article6/img_article6_tv_play.gif"
                class="tv-gif"
                v-if="!isPlay"/>
            </div>
            <div class="fade16 phone"
            :class="{'active': $parent.isfadeInActive && $parent.isfadeInA6}"
            v-on:mouseenter="toggleHoverMusic(true)"
            v-on:mouseleave="toggleHoverMusic(false)"
            @click="play()"
            v-else-if="targetIdx===2">
                <!-- 撐高度 -->
                <img
                src="@/assets/images/article6/img_article6_radio_v3@3x_hover.png"
                class="photo"
                style="visibility: hidden;" />
                <transition name="phone-toggle">
                    <img v-if="!isPlay"
                    key="hang"
                    src="@/assets/images/article6/img_article6_radio_v3@3x.png"
                    class="photo hang" />
                    <img v-else
                    key="pick"
                    src="@/assets/images/article6/img_article6_radio_v3@3x_hover.png"
                    class="photo pick" />

                    <!-- <a href=""
                    @click.prevent="toggleAudio();gaEvent('play_btn', 'radio_play');"
                    @mousedown="play()"
                    class="radio-btn">
                    </a> -->
                </transition>
            </div>
            <div class="fade16" :class="{'active': $parent.isfadeInActive && $parent.isfadeInA6}"
            v-on:mouseenter="toggleHoverMusic(true)"
            v-on:mouseleave="toggleHoverMusic(false)"
            v-else>
                <img src="@/assets/images/article6/img_article6_radio@3x.png"
                class="photo"/>
                <div class="radio-channel">
                    <img src="@/assets/images/article6/img_article6_radio_line@3x.png"
                    class="radio-line"
                    :style="{ left: percent + '%'}" />
                </div>

                <a href=""
                @click.prevent="toggleAudio();gaEvent('play_btn', 'radio_play');"
                @mousedown="play()"
                class="radio-btn" v-text="isPc ? '長按播放廣播' : '點擊播放廣播'">
                    點擊播放廣播
                </a>
            </div>
        </div>
        <div class="text-wrapper">
            <div class="img-title fade17"
            :class="{'active': $parent.isfadeInActive && $parent.isfadeInA6,
            'title-bg1':targetIdx===0,
            'title-bg2':targetIdx===1,
            'title-bg3':targetIdx===2}"></div>
            <h1 class="title fade18" v-text="data.title"
            :class="{'active': $parent.isfadeInActive && $parent.isfadeInA6}">
            高唱國旗歌培養愛國情操 成為有理想抱負的青年</h1>
            <div class="info-wrapper fade18"
            :class="{'active': $parent.isfadeInActive && $parent.isfadeInA6}">
                <p class="source">
                    【發布單位／{{data.title_unit}}】
                    <a href="" title="FB分享" class="fb-btn"
                    @click.prevent="$parent.onShare('fb', data.share_link);
                    gaEvent('share_fb', 'radio_sharefb');">
                        <img src="@/assets/images/btn_article_fb_n@3x.png" />
                    </a>
                    <a href="" title="Line分享" class="line-btn"
                    @click.prevent="$parent.onShare('line', data.share_link_line, data.line_text);
                    gaEvent('share_line', 'radio_shareline');">
                        <img src="@/assets/images/btn_article_line_n@3x.png" />
                    </a>
                </p>
            </div>
            <p class="description fade19"
            :class="{'active': $parent.isfadeInActive && $parent.isfadeInA6}" v-html="data.content">
                根據省政府教育廳頒布的命令，除朝會期間全體唱國歌、國旗歌和校歌之外，本處將於每節下課期間播放國旗歌，培養青年之愛國情操。
            </p>
        </div>
    </article>
</template>

<script>
import mixinMethod from '@/js/mixin/mixinMethod';

export default {
    name: 'radio6',
    props: {
        data: {
            type: Object,
            default() {
                return {
                    title: '',
                    title_unit: '',
                    content: '',
                    audio_path: '',
                    share_link: '',
                };
            },
        },
        isPc: {
            type: Boolean,
        },
        targetIdx: {
            type: Number,
        },
    },
    data() {
        return {
            gaCategory: '',
            // 是否正在播放
            isPlay: false,
            percent: 0,
            targetPercent: 13,
            isMobile: true,
            alreadyPlay: false,
            isHover: false,
        };
    },
    mounted() {
        const { userAgent } = window.navigator;
        this.isMobile = userAgent.indexOf('Mobile') > -1;
    },
    methods: {
        toggleAudio() {
            this.isPlay = !this.isPlay;
            if (this.isPlay) {
                if (this.isMobile) {
                    this.playMusic();
                } else {
                    this.play();
                }
            } else if (this.isMobile || this.percent < this.targetPercent) {
                this.stop();
            }
        },
        stop() {
            this.percent = 0;
            this.isPlay = false;
            if (window.pressTimer) {
                window.clearInterval(window.pressTimer);
            }
            this.playAudio('noiseMusic', true);
            this.playAudio('radioMusic', true);
            this.$parent.volBgMusic(1);
            this.alreadyPlay = false;
            if (this.$refs.tvVideo) this.$refs.tvVideo.pause();
        },
        playMusic() {
            const vm = this;
            if (this.targetIdx === 2 && this.isPlay) {
                this.stop();
                return;
            }
            this.isPlay = true;
            this.$parent.cancelOtherMusic('radioMusic');
            this.playAudio('hoverMusic', true);
            this.playAudio('radioMusic', false, () => {
                vm.stop();
            });
            window.pressTimer = window.setInterval(() => {
                if (vm.percent !== vm.targetPercent) {
                    vm.percent += 1;
                } else {
                    window.clearInterval(window.pressTimer);
                }
            }, 150);
        },
        playTV() {
            const video = this.$refs.tvVideo;
            if (!this.isPlay) {
                this.isPlay = true;
                this.$parent.cancelOtherMusic('noiseMusic');
                if (video) {
                    video.currentTime = 0;
                    video.play();
                }
                video.onended = () => {
                    this.isPlay = false;
                    this.playAudio('noiseMusic', true);
                    this.playAudio('radioMusic', true);
                    this.$parent.volBgMusic(1);
                    this.alreadyPlay = false;
                };
            } else {
                this.isPlay = false;
                video.pause();
                this.playAudio('noiseMusic', true);
                this.playAudio('radioMusic', true);
                this.$parent.volBgMusic(1);
                this.alreadyPlay = false;
            }
        },
        play() {
            const vm = this;
            if (this.isMobile && this.targetIdx === 0) {
                return;
            }
            if (this.isMobile && this.targetIdx === 2) {
                this.playMusic();
                return;
            }
            if (this.alreadyPlay) {
                this.stop();
                return;
            }
            this.isPlay = true;

            this.$parent.cancelOtherMusic('noiseMusic');
            this.playAudio('hoverMusic', true);

            if (this.targetIdx === 2) {
                this.alreadyPlay = true;
                // 等 fadeIn
                window.setTimeout(() => {
                    this.playAudio('radioMusic');
                }, 1800);
                return;
            }

            this.playAudio('noiseMusic');
            window.pressTimer = window.setInterval(() => {
                if (vm.percent !== vm.targetPercent) {
                    vm.percent += 1;
                } else {
                    vm.playAudio('noiseMusic', true);
                    vm.playAudio('radioMusic', false, () => {
                        vm.stop();
                    });
                    vm.alreadyPlay = true;
                }
            }, 150);
        },
        toggleHoverMusic(isPlay) {
            this.isHover = isPlay;
            if (this.alreadyPlay) {
                return;
            }
            this.playAudio('hoverMusic', !isPlay);
        },
    },
    watch: {
    },
    mixins: [mixinMethod],
};
</script>

<style scoped>
.phone-toggle-leave { opacity: 1; }
.phone-toggle-leave-active { transition: opacity 1s }
.phone-toggle-leave-to { opacity: 0; }
.phone-toggle-enter { opacity: 0; }
.phone-toggle-enter-active  { transition: opacity 2s }
.phone-toggle-enter-to { opacity: 1; }
</style>
<style lang="sass" scoped>
.photo-wrapper
    position: relative
    z-index: 2
    .phone
        margin-right: -1vw;
        margin-left: 3vw;
        margin-top: 0px;
        position: relative;
        // left: -9vw
        .hang
            position: absolute;
            right: -1%;
        .pick
            position: absolute;
            right: -0.5%;
            top: -3%;
.tv-gif
    width: 63%
    position: absolute
    left: 7%
    top: 7%
.tv-video
    width: 62%
    position: absolute
    left: 8%
    top: 0%
@media (max-width: 1024px)
    .photo-wrapper
        .phone
            margin-top: -10px;
@media (max-width: 768px)
    .photo-wrapper
        z-index: 3
        .phone
            margin-top: -20px;
            .hang
                position: absolute;
                right: -0.3%;
                top: 13%;
            .pick
                position: absolute;
                right: -0.5%;
                top: 10%;
    .tv-gif
        width: 57%
        left: 12%
        top: 2%
        transform: rotate(8deg)
    .tv-video
        width: 57%
        left: 12%
        top: -5%
        transform: rotate(8deg)
@media (max-width: 425px)
    .photo-wrapper
        .phone
            margin-right: 6vw;
            margin-left: 0vw;
            margin-top: 30px;
            left: -5vw
</style>
